import { hydrate } from "inferno-hydrate";
import App from "../shared/components/app/app";
import { BasePathBrowserRouter } from "./base-path-browser-router";
import { lazyHighlightjs } from "@utils/lazy-highlightjs";
import { loadLanguageInstances } from "@services/I18NextService";
import { verifyDynamicImports } from "@utils/dynamic-imports";
import { setupMarkdown } from "@utils/markdown";
import {
  getAimooLocaleCookie,
  resolveAimooInterfaceLanguage,
} from "@utils/aimoo-locale";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";

window.addEventListener("unhandledrejection", (ev: PromiseRejectionEvent) => {
  ev.preventDefault();
  console.error("Unhandled promise rejection:", ev.reason);
});

async function startClient() {
  // Allows to test imports from the browser console.
  window.checkLazyScripts = async () => {
    await verifyDynamicImports(true).then(x => console.debug(x));
  };

  window.history.scrollRestoration = "manual";

  setupMarkdown();
  lazyHighlightjs.enableLazyLoading();

  const fallbackLanguages = window.navigator.languages;
  const interfaceLanguage = resolveAimooInterfaceLanguage(
    getAimooLocaleCookie(),
    window.isoData?.myUserInfo?.local_user_view.local_user.interface_language,
  );

  // Make sure the language is loaded before hydration.
  const [[dateFnsLocale, i18n]] = await Promise.all([
    loadLanguageInstances(fallbackLanguages, interfaceLanguage),
  ]);

  try {
    if (interfaceLanguage !== "browser") {
      document.documentElement.lang = interfaceLanguage;
    }
  } catch {
    // ignore
  }

  const wrapper = (
    // @ts-expect-error Router typing for children
    <BasePathBrowserRouter>
      <App dateFnsLocale={dateFnsLocale} i18n={i18n} />
    </BasePathBrowserRouter>
  );

  // This element seems to be defined somewhere in infernojs codebase, so we cannot
  // access it via createRef
  // eslint-disable-next-line no-restricted-properties
  const root = document.getElementById("root");
  if (root) {
    hydrate(wrapper, root);

    root.dispatchEvent(new CustomEvent("lemmy-hydrated", { bubbles: true }));
  }
}

await startClient();
